<template>
  <div class="status-container">
    <template v-if="expanded">
      <div class="week-col py-3 mr-3">
        <div class="round-box glossary">M</div>
        <div class="round-box glossary">Tu</div>
        <div class="round-box glossary">W</div>
        <div class="round-box glossary">Th</div>
        <div class="round-box glossary">F</div>
      </div>
      <div
        v-for="n in Math.ceil(extendedStatuses.length / 5)"
        :key="n"
        class="week-col py-3"
      >
        <template v-for="index in 5">
          <NumeraiTooltip
            v-if="5 * (n - 1) + index <= extendedStatuses.length"
            :key="index"
            :text-list="[
              tooltipText(extendedStatuses[5 * (n - 1) + index - 1]),
              formatFilename(
                extendedStatuses[5 * (n - 1) + index - 1].filename,
              ),
              formatDay(extendedStatuses[5 * (n - 1) + index - 1]),
              formatSubmittedTime(extendedStatuses[5 * (n - 1) + index - 1]),
            ]"
          >
            <div
              class="round-box"
              :class="[
                { last: index === 5, dark: isDarkMode },
                extendedStatuses[5 * (n - 1) + index - 1].status,
              ]"
              @click="
                downloadSubmission(extendedStatuses[5 * (n - 1) + index - 1])
              "
            ></div>
          </NumeraiTooltip>
        </template>
      </div>
    </template>
    <template v-else>
      <div v-for="(roundData, index) in weeklyStatuses" :key="index">
        <NumeraiTooltip
          v-if="roundData.roundNumber"
          :text-list="[
            tooltipText(roundData),
            formatFilename(roundData.filename),
            formatSubmittedTime(roundData),
          ]"
        >
          <div
            class="day-container"
            :class="[roundData.status]"
            @click="downloadSubmission(roundData)"
          >
            {{ daysOfTheWeek[index] }}
          </div>
        </NumeraiTooltip>
        <div v-else class="day-container">{{ daysOfTheWeek[index] }}</div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import NumeraiTooltip from './NumeraiTooltip'
import { trimFilenameHash } from '@/lib/utils'
import moment from 'moment'

export default {
  components: {
    NumeraiTooltip,
  },
  props: {
    latestSubmissions: { type: Array, default: null },
    expanded: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters(['isDarkMode']),
    daysOfTheWeek() {
      // Second M for queued Mondays
      return ['M', 'Tu', 'W', 'Th', 'F', 'M']
    },
    weeklyStatuses() {
      if (!this.latestSubmissions) {
        return []
      } else {
        const tempSubmissions = []
        for (const submission of this.latestSubmissions) {
          tempSubmissions.push(submission)
          const day = moment(submission.roundOpen).format('ddd')

          // Break when we're on Monday (Saturday round) and not queued
          if (day === 'Sat' && submission.status !== 'queued') {
            break
          }
        }

        tempSubmissions.reverse()

        for (let i = tempSubmissions.length; i < 5; i++) {
          tempSubmissions.push({})
        }

        return tempSubmissions
      }
    },
    extendedStatuses() {
      if (!this.latestSubmissions) {
        return []
      } else {
        let temp = [...this.latestSubmissions].reverse()

        // Find the first Monday (start of the week)
        let i = 0
        for (; i < temp.length; i++) {
          if (moment(temp[i].roundCloseStaking).format('dddd') === 'Monday') {
            break
          }
        }
        temp = temp.slice(i, temp.length)

        return temp
      }
    },
  },
  methods: {
    formatFilename(filename) {
      return 'Filename: ' + trimFilenameHash(filename)
    },
    tooltipText(roundData) {
      let status

      switch (roundData.status) {
        case 'none':
          status = 'No submission'
          break
        case 'on-time':
          status = 'On-time'
          break
        case 'late':
          status = 'Late'
          break
        case 'queued':
          status = 'Queued'
          break
      }

      return `Round ${roundData.roundNumber}: ${status}`
    },
    formatSubmittedTime(roundData) {
      if (roundData.timestamp) {
        const uploaded = moment(roundData.timestamp).format('LT l')
        return `Submitted: ${uploaded}`
      }
    },
    formatDay(roundData) {
      return `Round Staking Close: ${moment(roundData.roundCloseStaking).format(
        'dddd l',
      )}`
    },
    async downloadSubmission(roundData) {
      this.$client.getSubmissionDownloadAuth(roundData.id).then(res => {
        window.open(res.url, '_blank')
      })
    },
  },
}
</script>
<style scoped>
.status-container {
  display: flex;
}

.day-container {
  width: 24px;
  height: 24px;
  margin-right: 6px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  color: var(--color-secondary);
  cursor: pointer;
}
.round-box {
  cursor: pointer;
}

.on-time,
.late {
  color: #ffffff;
}

.on-time {
  background: #44aa99;
}

.late {
  background: #ddcc77;
}

.none {
  background: #e4e4e4;
  color: #ffffff;
}

.queued {
  color: #ddcc77;
  border: 2px dashed #ddcc77;
}

.week-col {
  display: flex;
  flex-direction: column;
  margin-right: 6px;
  height: 108px;
}

.round-box {
  width: 12px;
  height: 12px;
  margin-bottom: 6px;
}

.round-box.last {
  margin-bottom: 0;
}

.round-box.on-time {
  background-color: #44aa99;
}

.round-box.none {
  background-color: #e4e4e4;
}

.round-box.none.dark {
  background-color: var(--color-grey50);
}

.round-box.late {
  background-color: #ddcc77;
}

.round-box.glossary {
  display: flex;
  align-items: center;
}
</style>
